import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router";
import { Spin } from "antd";
import dayjs from "dayjs";
import { RequestProposalCard } from "@companion-core/shared/app/Components/Requests/RequestProposalCard";
import { RequestPastRecommendationsProps } from "@companion-core/shared/app/Components/Requests/RequestDetail/RequestPastRecommendations/requestPastRecommendations.model";
import { RequestProposalCardVariant } from "@companion-core/shared/app/Components/Requests/RequestProposalCard/requestProposalCard.model";
import { useRequestPastProposals } from "./hooks/useRequestPastProposals";
import "@companion-core/web/src/Assets/Styles/scss/myRequestsPastProposals.scss";

export const RequestPastProposals = ({ requestData }: RequestPastRecommendationsProps) => {
  const navigate = useNavigate();
  const { t, isGetProposalsPending, proposals } = useRequestPastProposals({ requestData });
  const hasDigitalProposal = useMemo(() => requestData.has_digital_proposal, [requestData]);

  useEffect(() => {
    if (!hasDigitalProposal) navigate("/my-requests");
  }, [hasDigitalProposal]);

  return isGetProposalsPending ? (
    <Spin className="request-detail__loader" spinning={true} />
  ) : (
    <div data-testid="request-detail__past-proposals" className="request-detail__past-proposals">
      <div
        data-testid="request-detail__past-past-proposals--list"
        className="request-detail__past-proposals-list">
        {proposals.map((proposal, index) => (
          <RequestProposalCard
            key={proposal.id}
            testID="request-detail__past-past-proposals--card"
            id={proposal.id}
            tracked
            position={index}
            nbItems={proposals.length}
            url={window.location.href}
            title={`${t("request.my-requests.detail.proposal-card.title")} ${dayjs(proposal.generated_date).format("L")}`}
            status={proposal.status}
            variant={RequestProposalCardVariant.ModifyReservation}
            onClick={() => {
              navigate(`/my-requests/${requestData.id}/details/proposals/${proposal.id}`, {
                state: { canGoBack: true },
              });
            }}
          />
        ))}
      </div>
    </div>
  );
};
